export class InventoryClassificationPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "ScheduleMode",
            "format": ""
        },
        {
            "name": "schedule",
            "baseName": "schedule",
            "type": "ClassificationPolicySchedule",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InventoryClassificationPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
